import { Checkbox, FormControlLabel } from "@mui/material";

/**
 * Every configuration catalog opens showing only the records in use. One
 * component and one constant so the label, the look and the default cannot
 * drift apart across the sixteen screens that carry this filter.
 */
export const SHOW_ONLY_ACTIVES_DEFAULT = true;

interface ShowOnlyActivesCheckboxProps {
	checked: boolean;
	onChange: (value: boolean) => void;
}

export const ShowOnlyActivesCheckbox = ({
	checked,
	onChange,
}: ShowOnlyActivesCheckboxProps) => (
	<FormControlLabel
		control={
			<Checkbox
				checked={checked}
				onChange={(e) => onChange(e.target.checked)}
				size="small"
				color="primary"
			/>
		}
		label="Show Only Actives"
		sx={{ ml: 0, mr: 0, whiteSpace: "nowrap", userSelect: "none" }}
	/>
);
